// Content for "Astrology & Bhakti" series, Part 4
// Class by HG Balarāma Śakti Dāsa, Bhakti Saṅgha, on SB 5.14.8 (30 October 2021)
//
// This part reproduces Section 5 of the class as it appears on the presentation slides.

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Bhagavad-gītā 9.13',
        sloka: `mahātmānas tu māṁ pārtha
daivīṁ prakṛtim āśritāḥ
bhajanty ananya-manaso
jñātvā bhūtādim avyayam`,
        translation:
            'O son of Pṛthā (<strong>pārtha</strong>), those who are not deluded, the great souls (<strong>mahātmānaḥ</strong>), are under the protection of the divine nature (<strong>daivīṁ prakṛtim āśritāḥ</strong>). They are fully engaged in devotional service (<strong>bhajanty ananya-manasaḥ</strong>) because they know Me as the Supreme Personality of Godhead, original and inexhaustible (<strong>jñātvā bhūtādim avyayam</strong>).',
    },
    blocks: [
        {
            type: 'heading',
            headingText: 'Section 5 — The Basis of Astrological Chart and Calculations Is Karma',
        },
        {
            type: 'text',
            content:
                'Question, as posed on the slide: "My horoscope says so much about my life and it was all coming true, but ever since I have taken up Krishna consciousness, it has gone topsy-turvy… Doesn\'t astrology work for devotees?"',
        },
        {
            type: 'heading',
            headingText: 'HH Rādhānātha Swāmī Mahārāja Answers',
        },
        {
            type: 'text',
            content:
                'Astrology can predict what you will further experience in life according to your karma. This is the science of astrology, but I know one of the greatest astrologers in India who lives in Bangalore. He is a very genuine astrologer, and when a devotee of Lord Kṛṣṇa comes to him for consulting, he frankly tells them, "I can tell your destination according to your karma. But because you are a devotee and you have surrendered to Kṛṣṇa, not anything I may say necessarily will affect your life."',
        },
        {
            type: 'text',
            content:
                'Kṛṣṇa says in Bhagavad-gītā — <em>mahātmānas tu māṁ pārtha daivīṁ prakṛtim āśritāḥ</em> (Bhagavad-gītā 9.13): "O son of Pṛthā, those who are not deluded, the great souls, are under the protection of the divine nature. They are fully engaged in devotional service because they know Me as the Supreme Personality of Godhead, original and inexhaustible."',
        },
        {
            type: 'text',
            content:
                'When you surrender to Kṛṣṇa, you come under the influence of divine nature. <strong>Although, due to your past activities and karma you have a destiny, when you surrender to Kṛṣṇa you are no longer under the laws of karma.</strong> Kṛṣṇa can either let you go through the reactions of your karma, or He can intervene and separate you from that condition.',
        },
        {
            type: 'text',
            content:
                'In 1966, when Śrīla Prabhupāda had a very major heart attack, he was taken to a hospital. As soon as he regained his consciousness he said, "I cannot tolerate the doctors in hospital. Take me back to the temple." Later, at the temple, Śrīla Prabhupāda said, <strong>"It was my destined moment to die. But Kṛṣṇa has more work for me in His mission."</strong>',
        },
        {
            type: 'text',
            content:
                'So when you become a devotee, Kṛṣṇa could intervene in your destiny in any way He wants. Even if your destiny is to be prosperous and successful, Kṛṣṇa can bring complete calamity in your life and take away everything, if He feels that is good for your spiritual progress. And even if you are supposed to be diseased and die young, Kṛṣṇa can give you a healthy body, if He feels that is good for your spiritual progress. <strong>But unless you utilize your independence to surrender to Kṛṣṇa, then we are simply victimized by the results of our previous activities.</strong>',
        },
        {
            type: 'divider',
        },
        {
            type: 'text',
            content:
                'The next part in this series continues with Section 6: What Śrīla Prabhupāda himself said, in letters and conversations, about the role of astrology in a devotee\'s life.',
        },
    ],
};

export default content;
